import { SecurityInfo } from '../../../../domain/symbol.domain';
import { Quote } from '../../../../domain/quote.domain';
import { FormComponent } from '../../../../components/form/form.component';

import { EquityOrderAction, InsiderType, OptionOrderAction } from '../../domain/order.enum';
import {
  OrderGoodTil,
  OrderItem,
  OrderPriceAmount,
  OrderRequest,
  PriceSelection,
  SecurityExtendedTerms
} from '../../domain/order.domain';
import { TradingQuote } from '../../domain/order.quote.domain';
import {
  EquityFormModel,
  OrderEntryChangeFormModel
} from './order-entry.domain';

export type ChangeOrderAction<T extends OrderEntryChangeFormModel> =
  T extends EquityFormModel ? EquityOrderAction : OptionOrderAction;

export abstract class SimpleChangeOrderForm<T extends OrderEntryChangeFormModel> {
  changeOrderSymbol: SecurityInfo;
  shareholderStatus: InsiderType;
  orderAction: ChangeOrderAction<T>;
  changeOrderQuantity: number;
  orderPrice: PriceSelection;
  orderPriceAmount: OrderPriceAmount;
  orderGoodTil: OrderGoodTil;
  orderGoodTilDate: Date;
  orderAllOrNone: boolean;
  quoteLastPrice: number;
  totalFilledQuantity: number;
  latestRequestedQuantity: number;
  isOrderFilledOrHistorical: boolean;
  orderStatus: string;
  lastQuote: TradingQuote<Quote>;

  abstract submit(): boolean;
  abstract getForm(): FormComponent;
  abstract getModel(): T;
  abstract setModel(model: T): void;
  abstract getOrderItem(extendedTerms: SecurityExtendedTerms, security: SecurityInfo): OrderItem;
  abstract setPriceInfo(priceSelection: PriceSelection): void;
  abstract createCaptureRequest(): OrderRequest;
}

